<template>
  <div class="changeLog container-style">
    <el-card class="searchCard" shadow="never">
      <el-form :inline="true" :model="searchForm" class="form-inline">
        <el-form-item label="创建时间:">
          <datePicker @change="dateChange" :vModel="createTime" v-model="createTime"></datePicker>
        </el-form-item>
        <el-form-item label="商户编号:">
           <el-input v-model="searchForm.merchantId" placeholder="模糊搜索" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <!-- <el-button @click.native="searchClick">
            查询
          </el-button> -->
           <auth-button opt="search" :plain="true" icon="el-icon-search" @click.native="searchClick" label="查询" :loading="loadingTable"></auth-button>
          </el-form-item>
      </el-form>
     <div style="margin-bottom:20px">
       说明：目前查询仅展示最近三个月数据
     </div>
    </el-card>
     <el-card class="tableCard" shadow="never">
      <el-table
        stripe
        style="width:100%"
        align="center"
        v-loading="loadingTable"
        :data="tableData"
        :header-cell-style="{background:'#FAFAFA'}">
        <el-table-column
          label="序号"
          type="index"
          width="80"
          align="center">
        </el-table-column>
        <el-table-column
          prop="updateTime"
          label="变更时间"
          align="center">
        </el-table-column>
        <el-table-column
          prop="content"
          label="变更日志"
          align="center">
        </el-table-column>
        <el-table-column
          prop="operatorName"
          label="操作人"
          align="center">
        </el-table-column>
      </el-table>
    </el-card>
    <pagination :size="paginations.pageSize" @changePage="onChangeCurrentPage" :count="paginations.count" :page-no="paginations.pageNo"></pagination>
  </div>
</template>

<script>
import { parseTime } from '@/utils/formatTime'
import datePicker from '@/components/datePicker'
import pagination from '@/components/pagination'
import { getPayAccountUpdateLog } from '@/api/merchant-info'
export default {
  components: {
    datePicker,
    pagination
  },
  data () {
    const todayStr = (parseTime(new Date(), '{y}-{m}-{d} {h}:{i}:{s}')).substr(0, 10) + ' 23:59:59'
    const toadyZero = new Date(new Date().getTime() - 3600 * 1000 * 24 * 90)
    const todayZeroStr = parseTime(toadyZero, '{y}-{m}-{d} {h}:{i}:{s}').substr(0, 10) + ' 00:00:00'
    return {
      createTime: [todayZeroStr, todayStr],
      searchForm: {
        startTime: '',
        endTime: '',
        merchantId: ''
      },
      // 需要给分页组件传的信息
      paginations: {
        pageNo: 1,
        count: 0,
        pageSize: 10
      },
      loadingTable: false,
      tableData: []
    }
  },
  mounted () {
    this.dateChange(this.createTime)
    this.getList()
  },
  methods: {
    dateChange (value) {
      if (value !== null) {
        [this.searchForm.startTime, this.searchForm.endTime] = value
      } else {
        [this.searchForm.startTime, this.searchForm.endTime] = ['', '']
      }
    },
    /**
     * @description 改变当前页事件
     * @param  {number} page 当前页码
     */
    onChangeCurrentPage (page) {
      this.paginations.pageNo = page
      this.getList()
    },
    searchClick () {
      this.paginations.pageNo = 1
      this.getList()
    },
    createClick () {
      this.$router.push({ path: '/add-account' })
    },
    editActivityData () {

    },
    getList () {
      this.loadingTable = true
      const params = Object.assign(this.searchForm, this.paginations)
      console.log('params: ', params)
      getPayAccountUpdateLog(params).then(response => {
        this.loadingTable = false
        if (+response.error_code === 0) {
          this.tableData = response.data.logList
          this.paginations.count = response.data.total
        } else {
          this.$message({
            message: response.error_msg,
            type: 'error'
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>
